import reducers from './reducers';
import selectors from './selectors';
import { PromocodeStoreState } from './types';
import { createSliceWithThunks } from '../helpers';

const initialState: PromocodeStoreState = {
  loading: 'idle',
  error: null,
  entity: null
};

export const promocodeSlice = createSliceWithThunks({
  name: 'cartPage/promocode',
  initialState,
  selectors,
  reducers
});

export const {
  applyPromocode,
  removePromocode,
  updatePromocode
} = promocodeSlice.actions;

export const {
  selectLoading,
  selectAppliedStatus,
  selectPromocode
} = promocodeSlice.selectors;

export default promocodeSlice.reducer;
